import '../../../neb-utils/fetch-tracker';
import './neb-booking-app';

import { getParams, EVENT_ROUTE_CHANGE } from '@neb/router';
import { LitElement, html, css } from 'lit';

import NebIcon from '../../../../src/components/misc/neb-icon';
import { initialize as initLayoutMedia } from '../../../neb-app-layout/neb-layout-media-store';
import { PAGE_TYPES } from '../../../neb-lit-components/src/components/neb-pendo';
import { mapPopupStackRenderers } from '../../../neb-popup/src/renderers';
import { store, connect } from '../../../neb-redux/neb-redux-store';
import { LayoutService } from '../../../neb-redux/services/layout';
import { navigate } from '../../../neb-route/neb-route-state';
import { RENDERER_SVGS } from '../../../neb-styles/icons';
import {
  CSS_COLOR_WHITE,
  CSS_FONT_FAMILY,
  CSS_FONT_SIZE_HEADER,
  CSS_FONT_SIZE_BODY,
  CSS_COLOR_HIGHLIGHT,
} from '../../../neb-styles/neb-variables';
import { updateTenantShortName } from '../store/booking/bookingAction';

NebIcon.iconSets = {
  neb: RENDERER_SVGS,
};

export const ELEMENTS = {
  bookingApp: { id: 'booking-app' },
  popupStack: { id: 'popup-stack' },
};

const devTenantShortName = TENANT_SHORT_NAME;
const RENDERER_POPUPS = mapPopupStackRenderers();

class NebBookingGateway extends connect(store)(LitElement) {
  static get properties() {
    return {
      __fetchingError: Boolean,
      __isFetching: Boolean,
      __layout: {
        type: String,
        reflect: true,
      },
      __mode: String,
      __pattern: String,
      __tenantShortName: String,
      __tenantShortNameIsValid: Boolean,
    };
  }

  static get styles() {
    return css`
      .container {
        font-family: ${CSS_FONT_FAMILY};
        font-weight: bold;
        color: ${CSS_COLOR_WHITE};
        font-size: ${CSS_FONT_SIZE_HEADER};
        line-height: 1.5
        margin: 0;
        height: 100vh;

        background-image: url("/src/neb-login-screen.png");
        background-repeat: no-repeat;
        background-size: cover;

        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
      }

      .bodyContainer {
        height: auto;
        flex-grow: 1;
        width: 100%;
        background-color: ${CSS_COLOR_WHITE};
        color: ${CSS_COLOR_HIGHLIGHT};
        border: none;
        margin: 0;
      }

      .header, .errorTitle {
        font-size: 32px;
        padding-left: 7%;
      }

      .header, .footer {
        margin-top: 31px;
        margin-bottom: 27px;
        margin-right: 7%;
      }

      .errorTitle {
        padding-top: 40px;
      }

      .errorMsg {
        padding: 20px 7%;
        margin-right: 50%;
      }

      .footer {
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;

        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
      }

      .nebula-and-icon {
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-direction: row;
      }

      .created {
        font-size: ${CSS_FONT_SIZE_BODY};
        margin-right: 15px;
        font-weight: normal;
      }

      .nebula-icon {
        height: 32px;
        margin-right: 5px;
      }

      .popup-stack {
        position: fixed;
      }

      @media (max-width: 1100px) {
        .errorMsg {
          margin-right: 20%;
        }
      }

      @media (max-width: 700px) {
        .errorMsg  {
          margin-right: 10%;
        }
      }

      @media (max-width: 450px) {
        .errorMsg  {
          margin-right: 5%;
        }
      }

      @media (max-width: 375px) {
        .errorMsg  {
          margin-right: 0;
        }
      }
    `;
  }

  constructor() {
    super();

    this.initState();
    this.initHandlers();
  }

  initState() {
    this.__layout = '';
    this.__mode = devTenantShortName;
    this.__tenantShortName = devTenantShortName;

    this.__layoutService = new LayoutService(layout => {
      this.__layout = layout;
    });
  }

  initHandlers() {
    this.__handlers = {
      routeChange: e => {
        if (this.__pattern) {
          const res = getParams(this.__pattern, this.__getPathname());
          this.__tenantShortName = res.tenantShortName;
        }

        if (e) {
          store.dispatch(
            navigate(`#${e.detail}`, {
              sync: false,
              preventAppendHistory: true,
              replaceHistoryIfPrevented: false,
            }),
          );
        }
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();

    initLayoutMedia();

    window.addEventListener(EVENT_ROUTE_CHANGE, this.__handlers.routeChange);

    this.__layoutService.connect();
  }

  disconnectedCallback() {
    this.__layoutService.disconnect();

    window.removeEventListener(EVENT_ROUTE_CHANGE, this.__handlers.routeChange);

    super.disconnectedCallback();
  }

  _stateChanged(state) {
    const {
      booking: { tenantShortName },
      onlineBooking: { isFetching, fetchingError, isValid },
    } = state;

    this.__tenantShortName = tenantShortName;
    this.__isFetching = isFetching;
    this.__fetchingError = fetchingError;
    this.__tenantShortNameIsValid = isValid;
  }

  __computeNotFound() {
    return (
      !this.__isFetching &&
      (this.__tenantShortNameIsValid === false || this.__fetchingError !== null)
    );
  }

  __getPathname() {
    return window.location.pathname;
  }

  __modeChanged() {
    if (!this.__mode || typeof this.__mode !== 'string' || this.__mode === '') {
      this.__pattern = '/:*/:tenantShortName';

      this.__handlers.routeChange();
    } else {
      this.__tenantShortName = this.__mode;
    }
  }

  updated(changedProps) {
    if (changedProps.has('__mode')) this.__modeChanged(this.__mode);

    if (changedProps.has('__tenantShortName')) {
      store.dispatch(updateTenantShortName(this.__tenantShortName));
    }
  }

  render404Page() {
    return html`
      <head>
        <meta http-equiv="content-type" content="text/html;charset=UTF-8" />

        <meta
          name="viewport"
          content="width=device-width, minimum-scale=1.0, initial-scale=1.0, user-scalable=0"
        />

        <title>404 Booking Error</title>
      </head>

      <div id="Booking-404-container" class="container">
        <div id="Booking-404-header" class="header">
          Oops, this page cannot be found
        </div>

        <div id="Booking-404-body" class="bodyContainer">
          <div id="Booking-404-errorTitle" class="errorTitle">404 Error</div>

          <div id="Booking-404-errorMsg" class="errorMsg">
            Please make sure the link you've entered is correct or contact the
            practice to schedule your appointment.
          </div>
        </div>

        <div id="Booking-404-footer" class="footer">
          <div id="Booking-404-created">Created with</div>

          <div id="Booking-404-nebula-and-icon" class="nebula-and-icon">
            <img
              id="Booking-404-nebula-icon"
              class="nebula-icon"
              src="/src/nebula-mark.svg"
              alt="Nebula"
            />

            <div id="Booking-404-nebula" class="nebula">Nebula</div>
          </div>
        </div>
      </div>
    `;
  }

  renderBookingApp() {
    return html`
      <neb-booking-app
        id="${ELEMENTS.bookingApp.id}"
        .layout="${this.__layout}"
      ></neb-booking-app>

      <zen-popup-stack
        id="${ELEMENTS.popupStack.id}"
        class="popup-stack"
        .layout="${this.__layout}"
        .renderers="${RENDERER_POPUPS}"
      ></zen-popup-stack>
    `;
  }

  render() {
    return html`
      ${this.__computeNotFound()
        ? this.render404Page()
        : this.renderBookingApp()}

      <neb-pendo pagetype="${PAGE_TYPES.BOOKING}"></neb-pendo>
    `;
  }
}

customElements.define('neb-booking-gateway', NebBookingGateway);
